import { makeStyles, createStyles } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export const useStyles = makeStyles(
  () =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 0,
        marginBottom: 0,
      },
      divisor: {
        width: '100%',
        height: '1px',
        border: 'none',
        backgroundColor: sicrediColor.secondarySicredi,
      },
      littleLabel: {
        fontSize: 13,
        color: sicrediColor.secondarySicrediDarker,
      },
      selectIcon: {
        color: sicrediColor.primarySicredi,
        fontSize: 13,
        marginLeft: '-20px',
        pointerEvents: 'none',
      },
      containerAdicionar: {
        display: 'flex',
      },
      buttonAdicionar: {
        float: 'right',
        marginTop: '10px',
      },
      textItens: {
        marginBottom: '10px',
      },
      cursorDefault: {
        cursor: 'default',
      },
      itensList: {
        height: '57px',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        fontFamily: '"Exo 2"',
        fontSize: '18px',
        marginBottom: '10px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      itensContainerList: {
        display: 'flex',
        flexDirection: 'column',
      },
      itensContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderTop: '1px solid #CDD3CD',
        marginTop: '30px',
      },
      itemText: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
      },
      itensAnexoPautaRow: {
        gap: '16px',
      },
      itensContainerTitle: {
        fontFamily: 'Nunito',
        textAlign: 'center',
        color: '#323C32',
        marginTop: '10px',
      },
      deleteButton: {
        marginLeft: '4px',
      },
      abstencao: {
        marginLeft: '40px',
      },
      text: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      actions: {
        margin: '8px 0 16px',
      },
    }),
  {
    name: 'CadastroPautaModal',
  }
);
